import React, {useEffect, useState} from "react";
import {Actions} from "../../core";
import  _ from 'lodash';
import CloseIcon from "./icons8-close.svg"
import {ShareBtn} from "../Share/ShareBtn";

const JOBS_PATH = "/dark/contact/jobs";
// a shared link points at /dark/contact/jobs/<id> and opens that job's detail directly
const jobIdFromUrl = () => {
  const m = window.location.pathname.match(/\/contact\/jobs\/(\d+)/);
  return m ? m[1] : null;
};
const stripHtml = html => (html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();

export const Jobs = ()=>{
  const [jobs,setJobs]=useState([])
  const [select,setSelect]=useState(null)
  useEffect(() => {
    Actions.User.jobs().then(response=>{
      if(response?.data?.status===1){
          const list = response?.data?.data
          setJobs(list)
          const id = jobIdFromUrl()
          if(id) setSelect(_.find(list, j => String(j.id) === id) || null)
      }else{
        setJobs(null)
      }
    })
  }, []);

  // browser back/forward between the list and a job's detail
  useEffect(() => {
    const onPop = () => {
      const id = jobIdFromUrl()
      setSelect(id && jobs ? (_.find(jobs, j => String(j.id) === id) || null) : null)
    }
    window.addEventListener("popstate", onPop)
    return () => window.removeEventListener("popstate", onPop)
  }, [jobs]);

  const openJob = job => {
    setSelect(job)
    window.history.pushState({}, null, `${JOBS_PATH}/${job.id}`)
  }
  const closeJob = () => {
    setSelect(null)
    window.history.pushState({}, null, JOBS_PATH)
  }


  const renderJobs=()=>{

     if(jobs===null){
        return <span style={{fontSize:'1.125rem',lineHeight:`1.8rem`,fontFamily:`'FiraGO', sans-serif`}}>Thank you for your interest! We currently do not have any open positions. Please check back later for any updates.</span>
     }
     if(select){
        return  (
          <div>
            <div style={{display:'flex',flexDirection:'row', justifyContent:'space-between'}}>
              <span  style={{fontSize:'2rem',fontFamily:`meomari, FiraGO, sans-serif`,fontWeight:800}}  dangerouslySetInnerHTML={{__html:select?.title}}/>
              <div style={{display:'flex',alignItems:'center'}}>
                <div style={{display:'flex',alignSelf:'stretch',marginRight:10}}>
                  <ShareBtn
                    host={window.location.origin}
                    url={`${JOBS_PATH}/${select.id}`}
                    title={`Jobs // ${stripHtml(select.title)}`}
                    description={`Open position at Bassiani: ${stripHtml(select.title)}`}
                    image={window.location.origin+"/assets/share/bassiani.png"}
                  />
                </div>
                <div style={{display:'flex',justifyContent:'flex-end',fontSize:30,fontWeight:300,cursor:'pointer'}} onClick={closeJob}>
                  <img src={CloseIcon} alt="" width={30}/>
                </div>
              </div>
            </div>
            <div style={{marginTop:'1rem'}}>
              <div className="job-description" style={{fontSize:'1.125rem',lineHeight:`1.8rem`,fontFamily:`'FiraGO', sans-serif`}} dangerouslySetInnerHTML={{__html:select?.description}} />
            </div>
          </div>
        )
     }

     if(jobs.length>0){
        return  _.map(jobs, job=>{
            return (
              <div key={job.id} style={{borderBottom:'1px solid #c1bebe',fontSize:'2rem',cursor:'pointer',display:'flex',justifyContent:'space-between'}} onClick={()=>openJob(job)}>
                <div style={{fontFamily:`meomari, FiraGO, sans-serif`,fontWeight:800}}>
                  {job.title}
                </div>
                <div style={{fontSize:'2rem'}}>
                  +
                </div>
              </div>
            )
        })
     }

     return "loading ..."
  }

  return (
    <div className="lost-form">
      <div style={{
        padding:'1.5rem 2.1rem',
        height:'100%'
      }}>
        {
          renderJobs()
        }
      </div>

    </div>
  )
}
